import { Outlet } from "@tanstack/react-router";

/**
 * The outermost route element. Providers live in `main.tsx` because the router
 * needs auth state to resolve its guards, so they must sit above it.
 */
export function RootLayout() {
  return <Outlet />;
}
